// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"f92a163e","98":"5453d036","308":"855d679f","349":"2e95d691","476":"2e95d691","559":"855d679f","578":"2e95d691"}[chunkId] + ".chunk.css";
};